module.exports = __webpack_public_path__ + "static/media/r17.0a80836c.jpg";